
























































































































import {Vue, Mixins, Component} from 'vue-property-decorator';
import PageFormSelect from '@/components/board/common/PageFormSelect.vue';
import NoticeCategoryData from '@/components/board/mixins/NoticeCategoryData';
import {EditNoticeFormData} from '@/types';
// import {GetNoticeByNoticeNoRequest, GetNoticeByNoticeNoResponse} from 'supporter';
// import axios from 'axios';
import {setCookie} from '@/utils/cookieUtils';
import editor from '@/components/common/summernote/Index.vue';
import { namespace } from 'vuex-class';
import { Mall } from 'supporter';

const mallStore = namespace('mall');
@Component({
  components: {
    PageFormSelect,
    editor
  }
})
export default class QueryNoticeByNoticeNo extends Mixins(NoticeCategoryData) {
  private noticeNo: string = '';
  private isEditStatus: boolean = false;
  private isModifiedStatus: boolean = false;
  private mallNoData: {value: string; label: string}[] = [];

  @mallStore.Getter('malls')
  private malls!: Mall[];

  private editNoticeFormData: EditNoticeFormData = {
    mallNo: '',
    attachFiles: [],
    createdDateTime: '',
    mall: '',
    noticeAttachFiles: [],
    noticeCategory: '',
    noticeContent: '',
    noticeNo: 0,
    noticeTarget: '',
    noticeTitle: '',
    opened: true,
    readCount: 0,
    searchContent: '',
    writer: '',
    modifiedDateTime: '',
    modifier: ''
  };

  private editorContent: {noticeContent: string; searchContent: string} = {
    noticeContent: '',
    searchContent: ''
  };

  private getMallNoByMallName(mallName: string) {
    const mall = this.mallNoData.find((mall: any) => mall.label === mallName) || {value: '', label: ''};
    return mall.value;
  }

  private async getMalls() {
    this.mallNoData = this.malls.map((mall: Mall) => {
      return {value: mall.mallNo + '', label: mall.mallName};
    });
  }
  private getFile({uploadedFileName, originalFileName}: any) {
    // return new Promise((resolve, reject) => {
    //   axios({
    //     headers: {
    //       Version: process.env.VUE_APP_API_VERSION,
    //       'Content-Type': 'application/octet-stream'
    //     },
    //     method: 'get',
    //     url: url,
    //     responseType: 'arraybuffer'
    //   })
    //     .then((response) => {
    //       resolve(response);
    //     })
    //     .catch((error) => {
    //       reject(error);
    //     });
    // });

    const params = {fileName: uploadedFileName, container: 'ncp'};
    return this.$api
      .getStorage({params, responseType: 'blob'})
      .then(({data}) => {
        this.downfile(data, originalFileName);
      })
      .catch((error) => {});
  }
  private downfile(data: any, fileName: string): void {
    const blob = new Blob([data], {type: 'application/octet-stream'});
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      // IE workaround for "HTML7007: One or more blob URLs were
      // revoked by closing the blob for which they were created.
      // These URLs will no longer resolve as the data backing
      // the URL has been freed."
      window.navigator.msSaveBlob(blob, fileName);
    } else {
      const blobURL = window.URL.createObjectURL(blob);
      const tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      tempLink.href = blobURL;
      tempLink.setAttribute('download', fileName);

      // Safari thinks _blank anchor are pop ups. We only want to set _blank
      // target if the browser does not support the HTML5 download attribute.
      // This allows you to download files in desktop safari if pop up blocking
      // is enabled.
      if (typeof tempLink.download === 'undefined') {
        tempLink.setAttribute('target', '_blank');
      }

      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(blobURL);
    }
  }

  private down(file: any): void {
    this.getFile(file);
    // this.getFile(`${process.env.VUE_APP_API_URL}/storage?fileName=${file.uploadedFileName}`).then((response: any) => {
    //   const data = response.data;
    //   this.downfile(data, file.originalFileName);
    // });
  }

  private deleteImage(file: any): void {
    if (confirm('첨부파일을 삭제하시겠습니까?')) {
      this.editNoticeFormData.noticeAttachFiles = this.editNoticeFormData.noticeAttachFiles.filter((item: any) => item.uploadedFileName !== file.uploadedFileName) as [];
    }
  }
  private filech() {
    if ($('.file').length >= 10) {
      alert('첨부파일은 최대 10개만 등록 가능합니다.');
      return false;
    }
    (this.$refs.file as any).click();
    // $('[name=add_file]').trigger('click');
  }
  private uploadFile(event: any): void {
    let files = event.target.files;
    let file = files[0];
    if (!file.size) {
      return alert(this.toI18n('BOARD_NOTICE_EDIT_ALERT_SIZE_IS_0'));
    }

    const data = new FormData();
    data.append('file', file);

    if (file.size / Math.pow(1024, 2) > 5) {
      alert(this.toI18n('BOARD_NOTICE_EDIT_ALERT_SIZEFILE'));
      $(event.target).val('');
    } else {
      this.$api
        .postStorage({pathParams: {container: 'ncp'}, data})
        .catch(error => {
          if(error.data.code === 'F0005'){
            alert('파일 확장자명을 확인해주세요.');
          }
        })
        .then((res: any) => {
          const data = res.data;
          if (this.editNoticeFormData.noticeAttachFiles) {
            this.editNoticeFormData.noticeAttachFiles;
            Vue.set(this.editNoticeFormData.noticeAttachFiles, this.editNoticeFormData.noticeAttachFiles.length, data);
          }
        })
        .finally(() => {
          $(event.target).val('');
        });
      // axios({
      //   headers: {
      //     Version: process.env.VUE_APP_API_VERSION,
      //     'Content-Type': 'multipart/form-data'
      //   },
      //   data,
      //   method: 'post',
      //   url: `${process.env.VUE_APP_API_URL}/storage`
      // })
      //   .then((res: any) => {
      //     const data = res.data;
      //     if (this.editNoticeFormData.noticeAttachFiles) {
      //       this.editNoticeFormData.noticeAttachFiles;
      //       Vue.set(this.editNoticeFormData.noticeAttachFiles, this.editNoticeFormData.noticeAttachFiles.length, data);
      //     }
      //   })
      //   .catch(() => {
      //     alert('파일 확장자를 확인해주세요.');
      //   });
    }
  }

  private checkform(): boolean {
    if (!this.editNoticeFormData.noticeTitle) {
      alert(this.toI18n('BOARD_NOTICE_EDIT_ALERT_SUBJECT'));
      return false;
    }
    if (!this.editNoticeFormData.mallNo) {
      alert(this.toI18n('BOARD_NOTICE_EDIT_ALERT_MALL'));
      return false;
    }
    if (this.editNoticeFormData.noticeCategory === '') {
      alert(this.toI18n('BOARD_NOTICE_EDIT_ALERT_CATEGORY'));
      return false;
    }
    if (!this.editorContent.searchContent) {
      alert(this.toI18n('BOARD_NOTICE_EDIT_ALERT_CONTENT'));
      return false;
    }
    // if ($summernote.purifyCode().length > 16777215) {
    //   alert(this.toI18n('BOARD_NOTICE_EDIT_ALERT_LENGTH'));
    //   return false;
    // }
    return true;
  }

  private editorOnChange({html, text}: {html: string; text: string}): void {
    Object.assign(this.editorContent, {noticeContent: html, searchContent: text});
  }

  private save(): void {
    if (this.checkform()) {
      const mode = this.noticeNo ? this.toI18n('BOARD_NOTICE_EDIT_MODIFY') : this.toI18n('BOARD_NOTICE_EDIT_ENROLLMENT');
      if (confirm(`${this.toI18n('BOARD_NOTICE_EDIT_NOTICE')} ${mode}${this.toI18n('BOARD_NOTICE_EDIT_WILL_DO')}`)) {
        const data = Object.assign({}, this.editNoticeFormData, this.editorContent);
        if (this.noticeNo) {
          const params = {noticeNo: this.noticeNo};
          this.$api.PutNoticeByNoticeNo({params, data}).then((response: any) => {
            const status = response.status;
            if (status === 204) {
              //close & add cookie
              setCookie('boardEditNoticePopIsDone', '1');
              alert(this.toI18n('BOARD_NOTICE_EDIT_REVISE_SUCCESS'));
              window.close();
            }
          });
        } else {
          Object.assign(data, {noticeTarget: 'SERVICE_TO_PARTNER'});
          this.$api.PostNotice({data}).then((response: any) => {
            const status = response.status;
            if (status === 201) {
              //close & add cookie
              setCookie('boardAddNoticePopIsDone', '1');
              window.close();
            }
          });
        }
      }
    }
  }

  private close(): void {
    const mode = this.noticeNo ? this.toI18n('BOARD_NOTICE_EDIT_MODIFY') : this.toI18n('BOARD_NOTICE_EDIT_WRITE');
    if (confirm(`${this.toI18n('BOARD_NOTICE_EDIT_SURE_CANCEL')} ${mode}${this.toI18n('BOARD_NOTICE_EDIT_IS_NOT_SAVED')}`)) {
      window.close();
    }
  }

  private created(): void {
    document.body.classList.add('popup');
    Vue.set(this.noticeCategoryData, 0, {
      value: '',
      label: this.toI18n('BOARD_NOTICE_LIST_ANNOUNCEMENT_CATEGORY_SELECTION')
    });
    this.getMalls().then(() => {
      this.noticeNo = this.$route.params.noticeNo;
      if (this.noticeNo) {
        this.isEditStatus = true;
        this.$api.getNoticeByNoticeNo({pathParams: {noticeNo: this.noticeNo}}).then((respones: any) => {
          const data = respones.data;
          if (data.modifier) this.isModifiedStatus = true;
          const mallNo = this.getMallNoByMallName(data.mall);
          Object.assign(this.editNoticeFormData, data, {mallNo});
        });
      } else {
        Object.assign(this.editNoticeFormData, {mallNo: this.mallNoData[0].value});
      }
    });
  }
}
